<template lang="pug">
  v-container.fill-height.align-start.flex-column(fluid :fullscreen="$vuetify.breakpoint.smAndDown"  v-resize="onResize")
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    RequestDetailDialog(
      v-if="showRequestDetailDialog"
      :show="showRequestDetailDialog"
      :request="request"
      @close="onRequestDialogClose"
      )
    v-container(style="padding: 12px 0")
        v-card-title {{ $t('requestPage.requestsPageTitle') }}
        v-toolbar(dense flat v-if="$vuetify.breakpoint.mdAndUp")
          v-row
            v-spacer
            v-btn.mr-4.ml-4(@click="onCreatedButtonClick") {{ $t('requestPage.createdRequest') }}
            v-btn.mr-4(@click="onRejectedButtonClick") {{ $t('requestPage.rejectedRequest') }}
            v-btn.mr-4(@click="onApprovedButtonClick") {{ $t('requestPage.approvedRequest') }}
        v-toolbar.pa-0.ma-0.elevation-0.pl-0.ml-0(dense v-else)
          v-sheet(:max-width="cardWidth")
            v-slide-group.v-slide-group(multiple show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right" )
              v-slide-item
                v-btn.mr-4.ml-4(@click="onCreatedButtonClick") {{ $t('requestPage.createdRequest') }}
              v-slide-item
                v-btn.mr-4(@click="onRejectedButtonClick") {{ $t('requestPage.rejectedRequest') }}
              v-slide-item
                v-btn(@click="onApprovedButtonClick") {{ $t('requestPage.approvedRequest') }}


    v-container.pa-0.flex-shrink-0.flex-grow-1(ref="agGrid")
      AgGridVue.mt-2.ag-theme-balham(style="width: 100%; height: 100%; min-height: 500px;"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :pinnedBottomRowData="pinnedRowData"
        @grid-ready="onGridReady"
        @selection-changed="onSelectionChange"
        @row-double-clicked="onRequestDoubleRowClick"


        )
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {AgGridVue} from "ag-grid-vue";
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  ICellRendererParams,
  RowNode, ValueFormatterParams,
  ValueGetterParams
} from "ag-grid-community";
import {Action} from "vuex-class";
import {BOARDER_FETCH_BOARDER_GROUP_LIST, FETCH_REQUESTLIST} from "@/store/action-types";
import moment from "moment/moment";
import axios from "@/plugins/axios";
import _ from "lodash";
import CustomerModel from "@/model/customer/CustomerModel";
import {BusinessResponse} from "@/types/service-response";
import RequestDetailDialog from "@/components/RequestDetailDialog.vue";
import BoarderGroup from "@/model/boarder/BoarderGroup";

@Component({
  components: {
    AgGridVue,
    RequestDetailDialog
  }
})

export default class RequestsPage extends Vue {

  $refs!: {
    agGrid: HTMLElement
  }

  @Action(FETCH_REQUESTLIST) fetchReguest!: ({ (payload: any): Promise<Request[]> })
  @Action(BOARDER_FETCH_BOARDER_GROUP_LIST) fetchBoarderGroupList!: { (): Promise<BoarderGroup[]> }

  private gridOptions: GridOptions = {}
  // noinspection JSMismatchedCollectionQueryUpdate
  private columnDefs: ColDef[] = []
  // noinspection JSMismatchedCollectionQueryUpdate
  private gridApi: GridApi | null = null
  private columnApi: ColumnApi | null = null
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private currentSelection: any[] = []
  private pinnedRowData: any = []

  private showDebtorDetailDialog: boolean = false

  private rowData: Request[] = []
  private reguestList: Request[] = []
  private boarderGroupList: BoarderGroup[] = []
  private boarderGroupId: BoarderGroup[] = []
  private customers: CustomerModel[] = []
  private businessesList: BusinessResponse[] = []
  private customerId: string | null = ''
  private customerName: string | null = null
  private showRequestDetailDialog: boolean = false
  private request: any | null = null
  private cardWidth: number | null = null


  getSnackbarMessage (item: any): any {
    if(item === 'approved'){
      return this.snackBarMessage = this.$t('requestPage.boarderAccepted').toString()
    } else {
      return this.snackBarMessage = this.$t('requestPage.boarderRejected').toString()
    }
  }

  filteredBoarderGroup (){
    let data: any | null = null
    this.customers.forEach((item: CustomerModel) => {
      item.businesses.forEach((i: BusinessResponse) => {
        this.businessesList.push(i)
      })
      this.reguestList.forEach((item: any) => {
        this.customerId = item.data.customer.replace('/api/customer/', '')
      })
      this.businessesList.forEach((a: any) => {
        this.customerName = a.name
      })

    })
  }

  onRequestDoubleRowClick (item: any) {
    this.request = item.data
      if(this.request!.status.name === 'created'){
        this.showRequestDetailDialog = true
      } else {
        this.showRequestDetailDialog = false
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = 'Akcia nie je podporovaná'
      }


  }

  onRequestDialogClose (item: boolean,status: any) {
    if(item){
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.getSnackbarMessage(status)
      this.showRequestDetailDialog = false
    } else {
      this.showRequestDetailDialog = false
    }

    this.fetchRequestList('created')
  }

  async fetchRequestList(item: string): Promise<void> {
    let payload: string = item
    setTimeout(() => {this.gridOptions.api?.showLoadingOverlay()}, 0)
    try {
      this.reguestList = await this.fetchReguest(payload)

      this.rowData = this.reguestList
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
    finally {
      this.gridOptions.api?.hideOverlay()
    }
  }

  async fetchBoarder ():Promise<void>{
    try {
      this.boarderGroupList = await this.fetchBoarderGroupList()
      this.boarderGroupList.forEach((item: any) => {

        this.boarderGroupId.push(item)
      })
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    } finally {

    }
  }

  get selectionCount(): string {
    const count = this.currentSelection.length

    if (count > 0) {
      return `(${count})`
    }

    return ''
  }

  onGridReady(params: ICellRendererParams) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  onSelectionChange(params: GridOptions): void {
    this.currentSelection = params.api!.getSelectedRows()
  }

  closeDebtorDetailDialog(): void {
    this.showDebtorDetailDialog = false
  }

  createGridOptions(): GridOptions {
    return {
      rowSelection: 'multiple',
      rowDeselection: true,
      rowMultiSelectWithClick: false,
      suppressContextMenu: true,

      getRowClass(params: any): string {
        if (params.node.rowPinned) {
          return ''
        } else {
          return params.data.status.name === 'active' ? '' : 'gray-background-row'
        }
      },

      defaultColDef: {
        sortable: true,
        enableCellChangeFlash: true,
        floatingFilter: true,
        menuTabs: [],
        filter: 'agTextColumnFilter',
      },

      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        ],
      },

      cellFadeDelay: 1500,

      overlayLoadingTemplate:
          `<div class="ag-overlay-loading-center" style="font-size: 15px">
               <i class="fas fa-spinner fa-pulse"></i>
               <span style="padding-left: 10px"> ${this.$t('debtorsPage.loadingGridDataText')} </span>
           </div>`
    }
  }

  createColDefs(): ColDef[] {
    let hideDetails = false

    if (
        screen.orientation.type.includes('portrait')
        && ['xs', 'sm'].includes(this.$vuetify.breakpoint.name as string)
    ) {
      hideDetails = true
    }

    return [
      {
        flex: 2,
        minWidth: 120,
        filter: true,
        field: 'data.date',
        suppressMenu: hideDetails,
        headerName: this.$t('requestPage.date').toString(),
        valueFormatter(params: ValueFormatterParams): any {
          return params.data.createdAt ? moment(params.data.createdAt).format('D.M.YYYY') : ''
        }
      },
      {
        flex:2,
        minWidth: 430,
        field: 'data.familyName',
        suppressMenu: hideDetails,
        headerName:  this.$t('requestPage.fullName').toString(),
        filterParams: {
          debounceMs: 250,
          textCustomComparator: (filter: string, value: string, filterText: string) => {
            const filterTextNormalizeLowerCase = filterText.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const valueNormalizeLowerCase = value.toString().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();


            switch (filter) {
              case 'contains':
                let passed = true
                filterTextNormalizeLowerCase.split(' ').forEach((filterWord: string) => {
                  if (valueNormalizeLowerCase.indexOf(filterWord) < 0) {
                    passed = false;
                  }
                })
                return passed;
              default:
                return false;
            }
          }
        },
        valueGetter(params: ValueGetterParams): string {
          if (params.node.rowPinned) {
            return ""
          } else {
            return `${params.data.data.familyName} ${params.data.data.firstName}`
          }
        }
      },

      {
        width: 330,
        filter:false,
        headerName: this.$t('requestPage.kindName').toString(),
        valueFormatter(params: ValueFormatterParams): any {
          if(params.data.kind.name === 'onboarding') {
            return "Žiadosť o pridanie do systému"
          }

        }

      },
      {
        width: 300,
        filter:false,
        headerName: this.$t('requestPage.statusName').toString(),
        valueFormatter(params: ValueFormatterParams): any {
          if(params.data.status.name === 'created') {
            return 'Nová'
          }
          else if(params.data.status.name === 'pending') {
            return 'Nespracovaná'
          }
          else if(params.data.status.name === 'in_progress') {
            return 'V riešení'
          }
          else if(params.data.status.name === 'awaiting_information') {
            return 'Čaká na informácie'
          }
          else if(params.data.status.name === 'approved') {
            return 'Schválená'
          }
          else if(params.data.status.name === 'rejected') {
            return 'Zamietnutá'
          }

        }

      },
    ]
  }

  onCreatedButtonClick() {
    this.fetchRequestList('created')
  }

  onRejectedButtonClick () {
    this.fetchRequestList('rejected')
  }

  onApprovedButtonClick () {
    this.fetchRequestList('approved')

  }

  onResize () {
    if(this.$refs.agGrid) {
      const vw = this.$refs.agGrid.clientWidth
      this.cardWidth = vw
    }
  }

  async fetchCustomers ():Promise<void> {
    try {
      const response = await axios.get(`/api/customer`)
      this.customers =  _.orderBy(response.data, 'order')
      this.filteredBoarderGroup()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
  }

  beforeMount(): void {
      this.gridOptions = {
        rowSelection: 'multiple',
        rowDeselection: true,
        rowMultiSelectWithClick: false,
        suppressContextMenu: true,

        defaultColDef: {
          sortable: true,

          filter: 'agTextColumnFilter',

          filterParams: {
            debounceMs: 250,
            textFormatter: (value: string) => value.toString().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
          },

          floatingFilter: true,
          floatingFilterComponentParams: {
            suppressFilterButton: true
          }
        },

        statusBar: {
          statusPanels: [
            {statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'},
          ],
        },

        getRowClass(params: RowNode): string {
          return params.data.status.name === 'inactive' ? 'row-inactive' : ''
        }

    }
    this.gridOptions = this.createGridOptions()
    this.columnDefs = this.createColDefs()
  }

  created () {

  }

  mounted(): void {
    this.fetchRequestList('created')
    this.fetchBoarder()
    this.fetchCustomers()
  }
}
</script>

<style lang="stylus" scoped>

.v-slide-group
  >>> .v-slide-group__prev
    min-width 21px
    max-width 21px

  >>> .v-slide-group__next
    min-width 21px
    max-width 21px

.v-toolbar
  >>> .v-toolbar__content
    padding 0

</style>